// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAuditOutlinedSvg from "@fishx/icons-svg/es/asn/PAuditOutlined";
import FishxIcon from '../components/FishxIcon';

var PAuditOutlined = function PAuditOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAuditOutlinedSvg
  }));
};

PAuditOutlined.displayName = 'PAuditOutlined';
export default React.forwardRef(PAuditOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAuditOutlined.js
// module id = 3230
// module chunks = 0